function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { SvgIcon } from '@material-ui/core'; // === TABLE OF CONTENTS ===
// 1. ArrowDropDownIcon
// 2. ArrowDropUpIcon
// 3. ArrowDropLeftIcon
// 4. ArrowDropRightIcon
// 5. EastIcon
// 6. WestIcon
// 7. SouthIcon
// 8. NorthIcon
// 9. ExpandCloseIcon
// 10. ExpandOpenIcon
// 11. ArrowRight
// 12. ArrowLeft
// === END OF TABLE OF CONTENTS ===

export const ArrowDropDownIcon = props => /*#__PURE__*/React.createElement(SvgIcon, _extends({
  viewBox: "0 0 14 7"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M0.333344 0.333313L7.00001 6.99998L13.6667 0.333313H0.333344Z"
}));
export const ArrowDropUpIcon = props => /*#__PURE__*/React.createElement(SvgIcon, _extends({
  viewBox: "0 0 14 7"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M0.333344 6.66667L7.00001 0L13.6667 6.66667H0.333344Z"
}));
export const ArrowDropLeftIcon = props => /*#__PURE__*/React.createElement(SvgIcon, _extends({
  viewBox: "0 0 7 14"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M6.66667 0.333313L0 6.99998L6.66667 13.6666V0.333313Z"
}));
export const ArrowDropRightIcon = props => /*#__PURE__*/React.createElement(SvgIcon, _extends({
  viewBox: "0 0 7 14"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M0.333344 13.6666L7.00001 6.99998L0.333344 0.333313V13.6666Z"
}));
export const EastIcon = props => /*#__PURE__*/React.createElement(SvgIcon, _extends({
  viewBox: "0 0 28 20"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M18 0.666687L16.12 2.54669L22.2267 8.66669H0.666672V11.3334H22.2267L16.1067 17.4534L18 19.3334L27.3333 10L18 0.666687Z"
}));
export const WestIcon = props => /*#__PURE__*/React.createElement(SvgIcon, _extends({
  viewBox: "0 0 28 20"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M10 19.3334L11.88 17.4534L5.77334 11.3334H27.3333V8.66669H5.77334L11.8933 2.54669L10 0.666687L0.666672 10L10 19.3334Z"
}));
export const SouthIcon = props => /*#__PURE__*/React.createElement(SvgIcon, _extends({
  viewBox: "0 0 20 28"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M19.3333 18L17.4533 16.12L11.3333 22.2267V0.666687H8.66667V22.2267L2.54667 16.1067L0.666672 18L10 27.3334L19.3333 18Z"
}));
export const NorthIcon = props => /*#__PURE__*/React.createElement(SvgIcon, _extends({
  viewBox: "0 0 20 28"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M0.666656 10L2.54666 11.88L8.66666 5.77335V27.3334H11.3333V5.77335L17.4533 11.8934L19.3333 10L9.99999 0.666687L0.666656 10Z"
}));
export const ExpandCloseIcon = props => /*#__PURE__*/React.createElement(SvgIcon, _extends({
  viewBox: "0 0 16 11"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M8 0.666687L0 8.66669L1.88 10.5467L8 4.44002L14.12 10.5467L16 8.66669L8 0.666687Z"
}));
export const ExpandOpenIcon = props => /*#__PURE__*/React.createElement(SvgIcon, _extends({
  viewBox: "0 0 16 11"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M14.12 0.453369L8 6.56004L1.88 0.453369L0 2.33337L8 10.3334L16 2.33337L14.12 0.453369Z"
}));
export const ArrowRight = props => /*#__PURE__*/React.createElement(SvgIcon, _extends({
  viewBox: "0 0 11 16"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M0.453339 14.12L6.56001 8L0.453339 1.88L2.33334 0L10.3333 8L2.33334 16L0.453339 14.12Z"
}));
export const ArrowLeft = props => /*#__PURE__*/React.createElement(SvgIcon, _extends({
  viewBox: "0 0 11 16"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M10.5467 14.12L4.44 8L10.5467 1.88L8.66666 0L0.666664 8L8.66666 16L10.5467 14.12Z"
}));